import { getLayerFormPropertyDefaults } from './layerFormPropertyDefaults';
import { LayerFormProperty } from './normalizeLayerPropertiesInput';

export const ensureLayerFormProperties = ({
  properties,
  checkProperties,
  layerType,
  layerOrder,
}: {
  properties: LayerFormProperty[];
  checkProperties: string[];
  layerType: string;
  layerOrder: number;
}): LayerFormProperty[] => {
  const nextProperties = [...properties];
  const existingKeys = new Set(nextProperties.map((property) => property.key));

  for (const defaultProperty of getLayerFormPropertyDefaults({
    layerType,
    layerOrder,
  })) {
    if (existingKeys.has(defaultProperty.key)) {
      continue;
    }

    nextProperties.push({
      key: defaultProperty.key,
      value: defaultProperty.value,
      check: checkProperties.includes(defaultProperty.key),
    });
    existingKeys.add(defaultProperty.key);
  }

  return nextProperties;
};
